"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRangeFacet = exports.isCheckboxesFacet = exports.isCheckboxFilter = exports.isRangeFilter = void 0;
var __1 = require("..");
function isRangeFilter(arg) {
    return !__1.isUndefined(arg.min);
}
exports.isRangeFilter = isRangeFilter;
function isCheckboxFilter(arg) {
    return !__1.isUndefined(arg.checked);
}
exports.isCheckboxFilter = isCheckboxFilter;
function isCheckboxesFacet(arg) {
    return arg.type === 'checkbox';
}
exports.isCheckboxesFacet = isCheckboxesFacet;
function isRangeFacet(arg) {
    return arg.type === 'range';
}
exports.isRangeFacet = isRangeFacet;
